/* eslint-disable linebreak-style */
import React from 'react'
import Header from 'Components/Header'
import AboutMe from 'Components/AboutMe'
import Tech from 'Components/Tech'
import Projects from 'Components/Projects'
import OtherProjects from 'Components/OtherProjects'
import Blog from 'Components/Blog'
import Skills from 'Components/Skills'
import Footer from 'Components/Footer'

export const App = () => {
  return (
    <>

      <Header />
      <AboutMe />
      <Tech />
      <Projects />
      <OtherProjects />
      <Blog />
      <Skills />
      <Footer />

    </>
  )
}
